import '../../js/commons/initYPNamespace.js';

window.YP.Prov2Communication = function Prov2Communication() {
    let parent = null;

    function sendLocationChangedEvent() {
        parent.postMessage({
            type: 'LOCATION_CHANGED',
            payload: {
                pathname: window.location.pathname,
                hash: window.location.hash,
                search: window.location.search,
                origin: window.location.origin,
                href: window.location.href,
                title: document.title,
            },
        }, YP_CONFIG.proV2.url);
    }

    return {
        init(e) {
            if (parent === null) {
                parent = e.source;
            }
            window.addEventListener('hashchange', sendLocationChangedEvent);
            window.addEventListener('beforeunload', () => {
                parent.postMessage({
                    type: 'BEFORE_UNLOAD',
                }, YP_CONFIG.proV2.url);
            });
            window.addEventListener('click', () => {
                parent.postMessage({
                    type: 'WINDOW_CLICKED',
                }, YP_CONFIG.proV2.url);
            });
            parent.postMessage({
                type: 'INIT_DONE',
            }, YP_CONFIG.proV2.url);
            sendLocationChangedEvent();
        },
        modalDisplayedMessage(windowParent) {
            windowParent.postMessage({
                type: 'MODAL_DISPLAYED',
            }, YP_CONFIG.proV2.url);
        },
        reactModalDisplayedMessage(windowParent) {
            windowParent.postMessage({
                type: 'REACT_MODAL_DISPLAYED',
            }, YP_CONFIG.proV2.url);
        },
        modalClosedMessage(windowParent) {
            windowParent.postMessage({
                type: 'MODAL_CLOSED',
            }, YP_CONFIG.proV2.url);
        },
        invalidateTagsMessage(windowParent, apiVersion, tagTypes) {
            windowParent.postMessage({
                type: 'INVALIDATES_TAGS',
                payload: {
                    api: apiVersion,
                    tagTypes,
                },
            }, YP_CONFIG.proV2.url);
        },
        fullscreenEnabledMessage(windowParent) {
            windowParent.postMessage({
                type: 'FULLSCREEN_ENABLED',
            }, YP_CONFIG.proV2.url);
        },
        fullscreenDisabledMessage(windowParent) {
            windowParent.postMessage({
                type: 'FULLSCREEN_DISABLED',
            }, YP_CONFIG.proV2.url);
        },
        redirectAfterLogin(windowParent, nextUrl) {
            windowParent.postMessage({
                type: 'REDIRECT_AFTER_LOGIN',
                payload: {
                    nextUrl,
                },
            }, YP_CONFIG.proV2.url);
        },
        openSpreadLinksModal(windowParent) {
            windowParent.postMessage({
                type: 'OPEN_SPREAD_LINKS_MODAL',
            }, YP_CONFIG.proV2.url);
        },
        openTicketExportModal(windowParent, filters, sortBy, sortDirection) {
            windowParent.postMessage({
                type: 'OPEN_TICKET_EXPORT_MODAL',
                payload: { filters, sortBy, sortDirection },
            }, YP_CONFIG.proV2.url);
        },
        openOrderExportModal(windowParent, filters, sortBy, sortDirection) {
            windowParent.postMessage({
                type: 'OPEN_ORDER_EXPORT_MODAL',
                payload: { filters, sortBy, sortDirection },
            }, YP_CONFIG.proV2.url);
        },
        openRefundModal(windowParent, payload) {
            windowParent.postMessage({
                type: 'OPEN_REFUND_MODAL',
                payload,
            }, YP_CONFIG.proV2.url);
        },
    };
};

// Define the list of urls that should not be redirected to the new pro while waiting to be migrated
const legacyUrls = [
    '/activate/staff',
];
const isLoadedFromIframe = window.self !== window.top;
if (!isLoadedFromIframe
    && window.location.origin === YP_CONFIG.pro.url
    && !legacyUrls.some((url) => window.location.pathname.includes(url))
) {
    window.location.replace(window.location.toString().replace(
        YP_CONFIG.pro.url,
        YP_CONFIG.proV2.url,
    ));
}

window.addEventListener('message', (e) => {
    if (e.origin !== YP_CONFIG.proV2.url) {
        return;
    }
    switch (e.data.type) {
        case 'INIT':
            window.YP.Prov2Communication().init(e);
            break;
        case 'ON_BACK_DROP_CLICK':
            window.YP.ModalManager().closeModal();
            break;
        case 'SET_SIDEBAR_MINIMAL': {
            const page = document.querySelector('.c-page');
            if (e.data.payload.isSideBarMinimal) {
                page.classList.add('c-page--full');
            } else {
                page.classList.remove('c-page--full');
            }
            break;
        }
        case 'SET_HAS_BANNER': {
            document.body.classList.toggle('has-banner', e.data.payload.hasBanner);
            break;
        }
        default:
            throw new Error('Unknown message type', e.data.type);
    }
});
